import axios from "axios";
import { Base_URL } from "../url";

// Get blocks by Org
export const getBuildingBlocksByOrg = async (orgId) => {
  const response = await axios.get(
    `${Base_URL}/BuildingBlockMaster/GetByOrg/${orgId}`,
  );
  return response.data;
};

// Create block
export const createBuildingBlock = async (data) => {
  const response = await axios.post(
    `${Base_URL}/BuildingBlockMaster/Create`,
    data,
  );
  return response.data;
};

// Get tasks under block
export const getTasksByBuildingBlock = async (blockId) => {
  const response = await axios.get(
    `${Base_URL}/BuildingBlockMaster/GetTasks/${blockId}`,
  );
  return response.data;
};

export const getBuildingBlocksByOrgAndProject = async (orgId, projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/BuildingBlockMaster/GetByOrgAndProject/${orgId}/${projectId}`,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching Building Blocks";
  }
};

// Map task to building block
export const mapTaskToBuildingBlock = async (data) => {
  const response = await axios.post(
    `${Base_URL}/BuildingBlockMaster/MapTask`,
    data,
  );
  return response.data;
};

export const getBlockSummary = async (blockId, type) => {
  const response = await axios.get(
    `${Base_URL}/BuildingBlockMaster/GetBlockSummary/${blockId}/${type}`,
  );
  return response.data;
};

// Update building block
export const updateBuildingBlock = async (id, data) => {
  try {
    const response = await axios.put(
      `${Base_URL}/BuildingBlockMaster/Update/${id}`,
      data,
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating Building Block";
  }
};

// Get tickets under block
export const getTicketsByBuildingBlock = async (blockId) => {
  const response = await axios.get(
    `${Base_URL}/BuildingBlockMaster/GetTickets/${blockId}`,
  );
  return response.data;
};

// Map ticket to building block
export const mapTicketToBuildingBlock = async (data) => {
  const response = await axios.post(
    `${Base_URL}/BuildingBlockMaster/MapTicket`,
    data,
  );
  return response.data;
};

export const getBuildingBlocksByTask = async (taskId) => {
  const res = await axios.get(
    `${Base_URL}/BuildingBlockMaster/GetBuildingBlocksByTask/${taskId}`,
  );
  return res.data;
};

export const removeTaskMappingByTask = async (taskId) => {
  const res = await axios.delete(
    `${Base_URL}/BuildingBlockMaster/RemoveTaskMappingByTask/${taskId}`,
  );
  return res.data;
};

export const removeSpecificTaskMapping = async (taskId, blockId) => {
  const res = await axios.delete(
    `${Base_URL}/BuildingBlockMaster/RemoveTaskMapping/${taskId}/${blockId}`,
  );
  return res.data;
};

export const removeTicketMapping = async (ticketId, blockId) => {
  const response = await axios.delete(
    `${Base_URL}/BuildingBlockMaster/RemoveTicketMapping/${ticketId}/${blockId}`,
  );
  return response.data;
};
